import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { InjectionToken, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { TramiteConsultaQRService } from './service/tramite-consulta-qr.service';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

export const BASE_URL: InjectionToken<string> = new InjectionToken<string>('BASE_URL');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    RouterModule.forRoot([])    
  ],
  providers: [TramiteConsultaQRService, { provide: BASE_URL, useFactory: getBaseUrl },],
  bootstrap: [AppComponent]
})
export class AppModule { }
